// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"vUpt5JTtus4t_mqVYwa9D"};